export const NOTIFICATION_CENTER_TEST_IDS = {
  bell: 'insight-notifications-bell',
  badge: 'insight-notifications-badge',
  panel: 'insight-notifications-panel',
  emptyState: 'insight-notifications-empty',
  markAllRead: 'insight-notifications-mark-all-read',
  item: (id: string) => `insight-notification-${id}`,
  itemMarkRead: (id: string) => `insight-notification-read-${id}`,
  itemLink: (id: string) => `insight-notification-link-${id}`,
} as const;

export const NEEDS_ACTION_TEST_IDS = {
  strip: 'needs-action-strip',
  allClear: 'needs-action-all-clear',
  item: (id: string) => `needs-action-item-${id}`,
  itemLink: (id: string) => `needs-action-link-${id}`,
} as const;
